import { defineStore } from 'pinia';

type State = {
  isOpen: boolean;
  title?: string;
  subtitle?: string;
  okTitle?: string;
  cancelTitle?: string;
  action?: () => void;
  cancelAction?: () => void;
};

type OpenProps = {
  title?: string;
  subtitle?: string;
  okTitle?: string;
  cancelTitle?: string;
  action?: () => void;
  cancelAction?: () => void;
};

export const useAlertStore = defineStore('alertStore', {
  state: (): State => ({
    isOpen: false,
    title: undefined,
    subtitle: undefined,
    okTitle: undefined,
    cancelTitle: undefined,
    action: undefined,
    cancelAction: undefined,
  }),
  actions: {
    open({ title, subtitle, okTitle, cancelTitle, action, cancelAction }: OpenProps) {
      this.isOpen = true;
      this.title = title;
      this.subtitle = subtitle;
      this.cancelTitle = cancelTitle;
      this.okTitle = okTitle;
      this.action = action;
      this.cancelAction = cancelAction;
    },
    confirm() {
      this.action?.();
      this.close();
    },
    cancel() {
      this.cancelAction?.();
      this.close();
    },
    close() {
      this.isOpen = false;

      setTimeout(() => {
        this.title = undefined;
        this.subtitle = undefined;
      }, 300);
    },
  },
});
